/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 *
 */

import * as EnumsFromStore from '@tunnel-enums/store/actions';
import * as ModelsFromStore from '@tunnel-models/index';

/**
 * @function UserRightLoadActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UserRightLoadActionSuccess(data: any):
    ModelsFromStore.UserRightLoadActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.UserRightLoadActionTypes.USERRIGHTLOAD_SUCCESS
  }
}

/**
 * @function UserRightLoadActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UserRightLoadActionFail(errors: any):
    ModelsFromStore.UserRightLoadActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.UserRightLoadActionTypes.USERRIGHTLOAD_FAIL
  }
}
/**
 * @function UserRightLoadActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UserRightLoadActionInProgress():
    ModelsFromStore.UserRightLoadActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.UserRightLoadActionTypes.USERRIGHTLOAD_INPROGRESS
  }
}


/**
 * @function UserAuthorizationLoadActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UserAuthorizationLoadActionSuccess(data: any):
    ModelsFromStore.UserAuthorizationLoadActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.UserAuthorizationLoadActionTypes
            .USERAUTHORIZATIONLOAD_SUCCESS
  }
}

/**
 * @function UserAuthorizationLoadActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UserAuthorizationLoadActionFail(errors: any):
    ModelsFromStore.UserAuthorizationLoadActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.UserAuthorizationLoadActionTypes
            .USERAUTHORIZATIONLOAD_FAIL
  }
}
/**
 * @function UserAuthorizationLoadActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UserAuthorizationLoadActionInProgress():
    ModelsFromStore.UserAuthorizationLoadActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.UserAuthorizationLoadActionTypes
            .USERAUTHORIZATIONLOAD_INPROGRESS
  }
}


/**
 * @function LoginActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function LoginActionSuccess(data: any):
    ModelsFromStore.LoginActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.LoginActionTypes.LOGIN_SUCCESS
  }
}

/**
 * @function LoginActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function LoginActionFail(errors: any): ModelsFromStore.LoginActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.LoginActionTypes.LOGIN_FAIL
  }
}
/**
 * @function LoginActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function LoginActionInProgress(): ModelsFromStore.LoginActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.LoginActionTypes.LOGIN_INPROGRESS
  }
}



/**
 * @function CheckNewIncidentsActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CheckNewIncidentsActionSuccess(data: any):
    ModelsFromStore.CheckNewIncidentsActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.CheckNewIncidentsActionTypes
            .CHECKNEWINCIDENTS_SUCCESS
  }
}

/**
 * @function CheckNewIncidentsActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CheckNewIncidentsActionFail(errors: any):
    ModelsFromStore.CheckNewIncidentsActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.CheckNewIncidentsActionTypes.CHECKNEWINCIDENTS_FAIL
  }
}
/**
 * @function CheckNewIncidentsActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CheckNewIncidentsActionInProgress():
    ModelsFromStore.CheckNewIncidentsActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.CheckNewIncidentsActionTypes
            .CHECKNEWINCIDENTS_INPROGRESS
  }
}

/**
 * @function CheckIncidentsIsNotQualifyActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CheckIncidentsIsNotQualifyActionSuccess(data: any):
    ModelsFromStore.CheckIncidentsIsNotQualifyActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.CheckIncidentsIsNotQualifyActionTypes
            .CHECKINCIDENTSISNOTQUALIFY_SUCCESS
  }
}

/**
 * @function CheckIncidentsIsNotQualifyActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CheckIncidentsIsNotQualifyActionFail(errors: any):
    ModelsFromStore.CheckIncidentsIsNotQualifyActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.CheckIncidentsIsNotQualifyActionTypes
            .CHECKINCIDENTSISNOTQUALIFY_FAIL
  }
}
/**
 * @function CheckIncidentsIsNotQualifyActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CheckIncidentsIsNotQualifyActionInProgress():
    ModelsFromStore.CheckIncidentsIsNotQualifyActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.CheckIncidentsIsNotQualifyActionTypes
            .CHECKINCIDENTSISNOTQUALIFY_INPROGRESS
  }
}
/**
 * @function LoginActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ChangePassWordActionSuccess(data: any):
    ModelsFromStore.ChangePassWordActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.ChangePassWordActionTypes.CHANGEPASSWORD_SUCCESS
  }
}

/**
 * @function ChangePassWordActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ChangePassWordActionFail(errors: any):
    ModelsFromStore.ChangePassWordActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.ChangePassWordActionTypes.CHANGEPASSWORD_FAIL
  }
}
/**
 * @function ChangePassWordActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ChangePassWordActionInProgress():
    ModelsFromStore.ChangePassWordActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.ChangePassWordActionTypes.CHANGEPASSWORD_INPROGRESS
  }
}

/**
 * @function ResetActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ResetActionSuccess(): ModelsFromStore.ResetActionSuccess {
  return {
    payload: {

      reset: true,

    },

        type: EnumsFromStore.ResetActionTypes.RESET_SUCCESS
  }
}
/**
 * @function LogoutActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function LogoutActionSuccess(): ModelsFromStore.LogoutActionSuccess {
  return {
    payload: {

      error: null,
      loading: false,

    },

        type: EnumsFromStore.LogoutActionTypes.LOGOUT_SUCCESS
  }
}

/**
 * @function LogoutActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function LogoutActionFail(error: any): ModelsFromStore.LogoutActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.LogoutActionTypes.LOGOUT_FAIL
  }
}
/**
 * @function LogoutActionInProgress  -
 * @return { object }   payload
 * @returns { string }  type
 * @param {  }
 */
export function LogoutActionInProgress():
    ModelsFromStore.LogoutActionInProgress {
  return {
    payload: {

      loading: true,
    },

        type: EnumsFromStore.LogoutActionTypes.LOGOUT_INPROGRESS
  }
}
/**
 * @function CameraCreatedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraCreatedActionFail(error: any):
    ModelsFromStore.CameraCreatedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraCreatedActionTypes.CAMERACREATED_FAIL
  }
}
/**
 * @function CameraCreatedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraCreatedActionSuccess(data: any):
    ModelsFromStore.CameraCreatedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraCreatedActionTypes.CAMERACREATED_SUCCESS
  }
}

/**
 * @function CameraCreatedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraCreatedActionInProgress():
    ModelsFromStore.CameraCreatedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraCreatedActionTypes.CAMERACREATED_INPROGRESS
  }
}

/**
 * @function CameraUpdateActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraUpdateActionFail(error: any):
    ModelsFromStore.CameraUpdateActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraUpdateActionTypes.CAMERAUPDATE_FAIL
  }
}
/**
 * @function CameraUpdateActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraUpdateActionSuccess(data: any):
    ModelsFromStore.CameraUpdateActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraUpdateActionTypes.CAMERAUPDATE_SUCCESS
  }
}

/**
 * @function CameraUpdateActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraUpdateActionInProgress():
    ModelsFromStore.CameraUpdateActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraUpdateActionTypes.CAMERAUPDATE_INPROGRESS
  }
}

/**
 * @function CameraRemoveActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraRemoveActionFail(error: any):
    ModelsFromStore.CameraRemoveActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraRemoveActionTypes.CAMERAREMOVE_FAIL
  }
}
/**
 * @function CameraRemoveActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraRemoveActionSuccess(data: any):
    ModelsFromStore.CameraRemoveActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraRemoveActionTypes.CAMERAREMOVE_SUCCESS
  }
}

/**
 * @function CameraRemoveActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraRemoveActionInProgress():
    ModelsFromStore.CameraRemoveActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraRemoveActionTypes.CAMERAREMOVE_INPROGRESS
  }
}


/**
 * @function TunnelWatchCameraLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function TunnelWatchCameraLoadedActionFail(error: any):
    ModelsFromStore.TunnelWatchCameraLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.TunnelWatchCameraLoadedActionTypes
            .TUNNELWATCHCAMERALOADED_FAIL
  }
}

/**
 * @function TunnelWatchCameraLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function TunnelWatchCameraLoadedActionInProgress():
    ModelsFromStore.TunnelWatchCameraLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.TunnelWatchCameraLoadedActionTypes
            .TUNNELWATCHCAMERALOADED_INPROGRESS
  }
}

/**
 * @function TunnelWatchCameraLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function TunnelWatchCameraLoadedActionSuccess(data: any):
    ModelsFromStore.TunnelWatchCameraLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.TunnelWatchCameraLoadedActionTypes
            .TUNNELWATCHCAMERALOADED_SUCCESS
  }
}

/**
 * @function TunnelWatchOneCameraLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function TunnelWatchOneCameraLoadedActionFail(error: any):
    ModelsFromStore.TunnelWatchOneCameraLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.TunnelWatchOneCameraLoadedActionTypes
            .TUNNELWATCHONECAMERALOADED_FAIL
  }
}

/**
 * @function TunnelWatchOneCameraLoadedActionInProgress  -
 * @returns { object }   payload
 * @returns { string }  type
 * @param {  }
 */
export function TunnelWatchOneCameraLoadedActionInProgress():
    ModelsFromStore.TunnelWatchOneCameraLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.TunnelWatchOneCameraLoadedActionTypes
            .TUNNELWATCHONECAMERALOADED_INPROGRESS
  }
}

/**
 * @function TunnelWatchOneCameraLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function TunnelWatchOneCameraLoadedActionSuccess(data: any):
    ModelsFromStore.TunnelWatchOneCameraLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.TunnelWatchOneCameraLoadedActionTypes
            .TUNNELWATCHONECAMERALOADED_SUCCESS
  }
}


/**
 * @function SearchIncidentByIdActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SearchIncidentByIdActionFail(error: any):
    ModelsFromStore.SearchIncidentByIdActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type:
            EnumsFromStore.SearchIncidentByIdActionTypes.SEARCHINCIDENTBYID_FAIL
  }
}
/**
 * @function SearchIncidentByIdActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SearchIncidentByIdActionSuccess(data: any):
    ModelsFromStore.SearchIncidentByIdActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.SearchIncidentByIdActionTypes
            .SEARCHINCIDENTBYID_SUCCESS
  }
}

/**
 * @function SearchIncidentByIdActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SearchIncidentByIdActionInProgress():
    ModelsFromStore.SearchIncidentByIdActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.SearchIncidentByIdActionTypes
            .SEARCHINCIDENTBYID_INPROGRESS
  }
}
/**
 * @function ExploreLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExploreLoadedActionSuccess(data: any):
    ModelsFromStore.ExploreLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ExploreLoadedActionTypes.EXPLORELOADED_SUCCESS
  }
}

/**
 * @function ExploreLoadedActionReset  -
 * @returns { object }   payload
 * @returns { string }  type
 * @param {  }
 */
export function ExploreLoadedActionReset():
    ModelsFromStore.ExploreLoadedActionReset {
  return {
    type: EnumsFromStore.ExploreLoadedActionTypes.EXPLORELOADED_RESET
  }
}


/**
 * @function ExploreLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExploreLoadedActionFail(error: any):
    ModelsFromStore.ExploreLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ExploreLoadedActionTypes.EXPLORELOADED_FAIL
  }
}

/**
 * @function ExploreLoadedActionInProgress  -
 * @returns { object }   payload
 * @returns { string }  type
 * @param {  }
 */
export function ExploreLoadedActionInProgress():
    ModelsFromStore.ExploreLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ExploreLoadedActionTypes.EXPLORELOADED_INPROGRESS
  }
}

/**
 * @function NotificationLoadedActionInProgress  -
 * @returns { object }   payload
 * @returns { string }  type
 * @param {  }
 */
export function NotificationLoadedActionInProgress():
    ModelsFromStore.NotificationLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.NotificationLoadedActionTypes
            .NOTIFICATIONLOADED_INPROGRESS
  }
}

/**
 * @function NotificationLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function NotificationLoadedActionFail(error: any):
    ModelsFromStore.NotificationLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type:
            EnumsFromStore.NotificationLoadedActionTypes.NOTIFICATIONLOADED_FAIL
  }
}

/**
 * @function NotificationLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function NotificationLoadedActionSuccess(data: any):
    ModelsFromStore.NotificationLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.NotificationLoadedActionTypes
            .NOTIFICATIONLOADED_SUCCESS
  }
}

/**
 * @function DashboardLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function DashboardLoadedActionSuccess(data: any):
    ModelsFromStore.DashboardLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.DashboardLoadedActionTypes.DASHBOARDLOADED_SUCCESS
  }
}

/**
 * @function DashboardLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function DashboardLoadedActionFail(error: any):
    ModelsFromStore.DashboardLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.DashboardLoadedActionTypes.DASHBOARDLOADED_FAIL
  }
}

/**
 * @function DashboardLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function DashboardLoadedActionInProgress():
    ModelsFromStore.DashboardLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type:
            EnumsFromStore.DashboardLoadedActionTypes.DASHBOARDLOADED_INPROGRESS
  }
}

/**
 * @function SystemSettingsActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SystemSettingsActionInProgress():
    ModelsFromStore.SystemSettingsActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.SystemSettingsActionTypes.SYSTEMSETTINGS_INPROGRESS
  }
}

/**
 * @function SystemSettingsActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SystemSettingsActionFail(error: any):
    ModelsFromStore.SystemSettingsActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.SystemSettingsActionTypes.SYSTEMSETTINGS_FAIL
  }
}
/**
 * @function SystemSettingsActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SystemSettingsActionSuccess(data: any):
    ModelsFromStore.SystemSettingsActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.SystemSettingsActionTypes.SYSTEMSETTINGS_SUCCESS
  }
}

/**
 * @function SectionSettingsActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSettingsActionInProgress():
    ModelsFromStore.SectionSettingsActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type:
            EnumsFromStore.SectionSettingsActionTypes.SECTIONSETTINGS_INPROGRESS
  }
}

/**
 * @function SectionSettingsActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSettingsActionFail(error: any):
    ModelsFromStore.SectionSettingsActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.SectionSettingsActionTypes.SECTIONSETTINGS_FAIL
  }
}
/**
 * @function SectionSettingsActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSettingsActionSuccess(data: any):
    ModelsFromStore.SectionSettingsActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.SectionSettingsActionTypes.SECTIONSETTINGS_SUCCESS
  }
}

/**
 * @function SectionZonesLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionZonesLoadedActionInProgress():
    ModelsFromStore.SectionZonesLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.SectionZonesLoadedActionTypes
            .SECTIONZONESLOADED_INPROGRESS
  }
}

/**
 * @function SectionZonesLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionZonesLoadedActionFail(error: any):
    ModelsFromStore.SectionZonesLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type:
            EnumsFromStore.SectionZonesLoadedActionTypes.SECTIONZONESLOADED_FAIL
  }
}
/**
 * @function SectionZonesLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionZonesLoadedActionSuccess(data: any):
    ModelsFromStore.SectionZonesLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.SectionZonesLoadedActionTypes
            .SECTIONZONESLOADED_SUCCESS
  }
}


/**
 * @function SectionZonesLoadedActionReset  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionZonesLoadedActionReset():
    ModelsFromStore.SectionZonesLoadedActionReset {
  return {
    type: EnumsFromStore.SectionZonesLoadedActionTypes.SECTIONZONESLOADED_RESET
  }
}



/**
 * @function SetSectionSettingsActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SetSectionSettingsActionInProgress():
    ModelsFromStore.SetSectionSettingsActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.SetSectionSettingsActionTypes
            .SETSECTIONSETTINGS_INPROGRESS
  }
}

/**
 * @function SetSectionSettingsActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SetSectionSettingsActionFail(error: any):
    ModelsFromStore.SetSectionSettingsActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type:
            EnumsFromStore.SetSectionSettingsActionTypes.SETSECTIONSETTINGS_FAIL
  }
}
/**
 * @function SetSectionSettingsActionReset -
 * @returns { string }  type
 * @param { any }
 */
export function SetSectionSettingsActionReset():
    ModelsFromStore.SetSectionSettingsActionReset {
  return {
    type: EnumsFromStore.SetSectionSettingsActionTypes.SETSECTIONSETTINGS_RESET
  }
}
/**
 * @function SetSectionSettingsActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SetSectionSettingsActionSuccess(data: any):
    ModelsFromStore.SetSectionSettingsActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.SetSectionSettingsActionTypes
            .SETSECTIONSETTINGS_SUCCESS
  }
}

/**
 * @function SectionSaveZoneActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSaveZoneActionInProgress():
    ModelsFromStore.SectionSaveZoneActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type:
            EnumsFromStore.SectionSaveZoneActionTypes.SECTIONSAVEZONE_INPROGRESS
  }
}

/**
 * @function SectionSaveZoneActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSaveZoneActionFail(error: any):
    ModelsFromStore.SectionSaveZoneActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.SectionSaveZoneActionTypes.SECTIONSAVEZONE_FAIL
  }
}
/**
 * @function SectionSaveZoneActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSaveZoneActionSuccess(data: any):
    ModelsFromStore.SectionSaveZoneActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.SectionSaveZoneActionTypes.SECTIONSAVEZONE_SUCCESS
  }
}

/**
 * @function ImpactSettingActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ImpactSettingActionSuccess(data: any):
    ModelsFromStore.ImpactSettingActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ImpactSettingActionTypes.IMPACTSETTING_SUCCESS
  }
}
/**
 * @function ImpactSettingActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ImpactSettingActionFail(error: any):
    ModelsFromStore.ImpactSettingActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ImpactSettingActionTypes.IMPACTSETTING_FAIL
  }
}

/**
 * @function ImpactSettingActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ImpactSettingActionInProgress():
    ModelsFromStore.ImpactSettingActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ImpactSettingActionTypes.IMPACTSETTING_INPROGRESS
  }
}

/**
 * @function IncidentInhibateActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateActionSuccess(data: any):
    ModelsFromStore.IncidentInhibateActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type:
            EnumsFromStore.IncidentInhibateActionTypes.INCIDENTINHIBATE_SUCCESS
  }
}
/**
 * @function IncidentInhibateActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateActionFail(error: any):
    ModelsFromStore.IncidentInhibateActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.IncidentInhibateActionTypes.INCIDENTINHIBATE_FAIL
  }
}

/**
 * @function IncidentInhibateActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateActionInProgress():
    ModelsFromStore.IncidentInhibateActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.IncidentInhibateActionTypes
            .INCIDENTINHIBATE_INPROGRESS
  }
}

/**
 * @function IncidentRulesActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentRulesActionSuccess(data: any):
    ModelsFromStore.IncidentRulesActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.IncidentRulesActionTypes.INCIDENTRULES_SUCCESS
  }
}
/**
 * @function IncidentRulesActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentRulesActionFail(error: any):
    ModelsFromStore.IncidentRulesActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.IncidentRulesActionTypes.INCIDENTRULES_FAIL
  }
}

/**
 * @function IncidentRulesActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentRulesActionInProgress():
    ModelsFromStore.IncidentRulesActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.IncidentRulesActionTypes.INCIDENTRULES_INPROGRESS
  }
}

/**
 * @function CameraLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraLoadedActionInProgress():
    ModelsFromStore.CameraLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraLoadedActionTypes.CAMERALOADED_INPROGRESS
  }
}

/**
 * @function CameraLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraLoadedActionFail(error: any):
    ModelsFromStore.CameraLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraLoadedActionTypes.CAMERALOADED_FAIL
  }
}

/**
 * @function CameraLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraLoadedActionSuccess(data: any):
    ModelsFromStore.CameraLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraLoadedActionTypes.CAMERALOADED_SUCCESS
  }
}

/**
 * @function CameraSettingLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSettingLoadedActionSuccess(data: any):
    ModelsFromStore.CameraSettingLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraSettingLoadedActionTypes
            .CAMERASETTINGLOADED_SUCCESS
  }
}
/**
 * @function CameraSettingLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSettingLoadedActionFail(error: any):
    ModelsFromStore.CameraSettingLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraSettingLoadedActionTypes
            .CAMERASETTINGLOADED_FAIL
  }
}

/**
 * @function CameraSettingLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSettingLoadedActionInProgress():
    ModelsFromStore.CameraSettingLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraSettingLoadedActionTypes
            .CAMERASETTINGLOADED_INPROGRESS
  }
}

/**
 * @function CameraSettingActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSettingActionInProgress():
    ModelsFromStore.CameraSettingActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraSettingActionTypes.CAMERASETTING_INPROGRESS
  }
}

/**
 * @function CameraSettingActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSettingActionFail(error: any):
    ModelsFromStore.CameraSettingActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraSettingActionTypes.CAMERASETTING_FAIL
  }
}

/**
 * @function CameraSettingActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSettingActionSuccess(data: any):
    ModelsFromStore.CameraSettingActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraSettingActionTypes.CAMERASETTING_SUCCESS
  }
}

/**
 * @function CameraInhibitionsLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraInhibitionsLoadedActionInProgress():
    ModelsFromStore.CameraInhibitionsLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraInhibitionsLoadedActionTypes
            .CAMERAINHIBITIONSLOADED_INPROGRESS
  }
}

/**
 * @function CameraInhibitionsLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraInhibitionsLoadedActionFail(error: any):
    ModelsFromStore.CameraInhibitionsLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraInhibitionsLoadedActionTypes
            .CAMERAINHIBITIONSLOADED_FAIL
  }
}

/**
 * @function CameraInhibitionsLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraInhibitionsLoadedActionSuccess(data: any):
    ModelsFromStore.CameraInhibitionsLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraInhibitionsLoadedActionTypes
            .CAMERAINHIBITIONSLOADED_SUCCESS
  }
}

/**
 * @function IncidentTypesLoadedActionInProgress
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentTypesLoadedActionInProgress():
    ModelsFromStore.IncidentTypesLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.IncidentTypesLoadedActionTypes
            .INCIDENTTYPESLOADED_INPROGRESS
  }
}

/**
 * @function IncidentTypesLoadedActionFail
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentTypesLoadedActionFail(error: any):
    ModelsFromStore.IncidentTypesLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.IncidentTypesLoadedActionTypes
            .INCIDENTTYPESLOADED_FAIL
  }
}

/**
 * @function IncidentTypesLoadedActionSuccess
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentTypesLoadedActionSuccess(data: any):
    ModelsFromStore.IncidentTypesLoadedActionSuccess {
  let incidentTypes: any;
  if (data) {
    incidentTypes = data.filter((v: any) => v.label !== 'FAST');
  }
  return {
    payload: {

      data: incidentTypes,
      loading: false,

    },

        type: EnumsFromStore.IncidentTypesLoadedActionTypes
            .INCIDENTTYPESLOADED_SUCCESS
  }
}

/**
 * @function ExtractorVideoActionInProgress
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtractorVideoActionInProgress():
    ModelsFromStore.ExtractorVideoActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ExtractorVideoActionTypes.EXTRACTORVIDEO_INPROGRESS
  }
}

/**
 * @function ExtractorVideoActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtractorVideoActionFail(error: any):
    ModelsFromStore.ExtractorVideoActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ExtractorVideoActionTypes.EXTRACTORVIDEO_FAIL
  }
}

/**
 * @function ExtractorVideoActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtractorVideoActionSuccess(data: any):
    ModelsFromStore.ExtractorVideoActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ExtractorVideoActionTypes.EXTRACTORVIDEO_SUCCESS
  }
}

/**
 * @function ExtractorPdfIncidentActionInProgress
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtractorPdfIncidentActionInProgress():
    ModelsFromStore.ExtractorPdfIncidentActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ExtractorPdfIncidentActionTypes
            .EXTRACTORPDFINCIDENT_INPROGRESS
  }
}

/**
 * @function ExtractorPdfIncidentActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtractorPdfIncidentActionFail(error: any):
    ModelsFromStore.ExtractorPdfIncidentActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ExtractorPdfIncidentActionTypes
            .EXTRACTORPDFINCIDENT_FAIL
  }
}

/**
 * @function ExtractorPdfIncidentActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtractorPdfIncidentActionSuccess(data: any):
    ModelsFromStore.ExtractorPdfIncidentActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ExtractorPdfIncidentActionTypes
            .EXTRACTORPDFINCIDENT_SUCCESS
  }
}


/**
 * @function ExtractorCameraListActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtractorCameraListActionInProgress():
    ModelsFromStore.ExtractorCameraListActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ExtractorCameraListActionTypes
            .EXTRACTORCAMERALIST_INPROGRESS
  }
}

/**
 * @function ExtractorCameraListActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtractorCameraListActionFail(error: any):
    ModelsFromStore.ExtractorCameraListActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ExtractorCameraListActionTypes
            .EXTRACTORCAMERALIST_FAIL
  }
}

/**
 * @function ExtractorCameraListActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtractorCameraListActionSuccess(data: any):
    ModelsFromStore.ExtractorCameraListActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ExtractorCameraListActionTypes
            .EXTRACTORCAMERALIST_SUCCESS
  }
}

/**
 * @function ImpactIsQualifiedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ImpactIsQualifiedActionSuccess(data: any):
    ModelsFromStore.ImpactIsQualifiedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ImpactIsQualifiedActionTypes
            .IMPACTISQUALIFIED_SUCCESS
  }
}
/**
 * @function ImpactIsQualifiedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ImpactIsQualifiedActionFail(error: any):
    ModelsFromStore.ImpactIsQualifiedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ImpactIsQualifiedActionTypes.IMPACTISQUALIFIED_FAIL
  }
}
/**
 * @function ImpactIsQualifiedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ImpactIsQualifiedActionInProgress():
    ModelsFromStore.ImpactIsQualifiedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ImpactIsQualifiedActionTypes
            .IMPACTISQUALIFIED_INPROGRESS
  }
}
/**
 * @function ImpactIsQualifiedActionFail  -
 * @returns { object }   payload
 * @returns { string }  type
 * @param { any }
 */
export function ImpactFakeDeletedActionFail(error: any):
    ModelsFromStore.ImpactFakeDeletedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ImpactFakeDeletedActionTypes.IMPACTFAKEDELETED_FAIL
  }
}
/**
 * @function ImpactFakeDeletedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ImpactFakeDeletedActionSuccess(data: any):
    ModelsFromStore.ImpactFakeDeletedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ImpactFakeDeletedActionTypes
            .IMPACTFAKEDELETED_SUCCESS
  }
}
/**
 * @function ImpactFakeDeletedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ImpactFakeDeletedActionInProgress():
    ModelsFromStore.ImpactFakeDeletedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ImpactFakeDeletedActionTypes
            .IMPACTFAKEDELETED_INPROGRESS
  }
}

/**
 * @function CitilogIncidentLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CitilogIncidentLoadedActionInProgress():
    ModelsFromStore.CitilogIncidentLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CitilogIncidentLoadedActionTypes
            .CITILOGINCIDENTLOADED_INPROGRESS
  }
}

/**
 * @function CitilogIncidentLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CitilogIncidentLoadedActionFail(error: any):
    ModelsFromStore.CitilogIncidentLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CitilogIncidentLoadedActionTypes
            .CITILOGINCIDENTLOADED_FAIL
  }
}

/**
 * @function CitilogIncidentLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CitilogIncidentLoadedActionSuccess(data: any):
    ModelsFromStore.CitilogIncidentLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CitilogIncidentLoadedActionTypes
            .CITILOGINCIDENTLOADED_SUCCESS
  }
}


/**
 * @function CitilogIncidentExtractedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CitilogIncidentExtractedActionInProgress():
    ModelsFromStore.CitilogIncidentExtractedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CitilogIncidentExtractedActionTypes
            .CITILOGINCIDENTEXTRACTED_INPROGRESS
  }
}

/**
 * @function CitilogIncidentExtractedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CitilogIncidentExtractedActionFail(error: any):
    ModelsFromStore.CitilogIncidentExtractedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CitilogIncidentExtractedActionTypes
            .CITILOGINCIDENTEXTRACTED_FAIL
  }
}

/**
 * @function CitilogIncidentExtractedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CitilogIncidentExtractedActionSuccess(data: any):
    ModelsFromStore.CitilogIncidentExtractedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CitilogIncidentExtractedActionTypes
            .CITILOGINCIDENTEXTRACTED_SUCCESS
  }
}



/**
 * @function ExploreExtractIncidentActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExploreExtractIncidentActionFail(error: any):
    ModelsFromStore.ExploreExtractIncidentActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ExploreExtractIncidentActionTypes
            .EXPLOREEXTRACTINCIDENT_FAIL
  }
}

/**
 * @function ExploreExtractIncidentActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExploreExtractIncidentActionSuccess(data: any):
    ModelsFromStore.ExploreExtractIncidentActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ExploreExtractIncidentActionTypes
            .EXPLOREEXTRACTINCIDENT_SUCCESS
  }
}

/**
 * @function ExploreExtractIncidentActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExploreExtractIncidentActionInProgress():
    ModelsFromStore.ExploreExtractIncidentActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ExploreExtractIncidentActionTypes
            .EXPLOREEXTRACTINCIDENT_INPROGRESS
  }
}



/**
 * @function CameraByIdLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraByIdLoadedActionFail(error: any):
    ModelsFromStore.CameraByIdLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraByIdLoadedActionTypes.CAMERABYIDLOADED_FAIL
  }
}
/**
 * @function CameraByIdLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraByIdLoadedActionInProgress():
    ModelsFromStore.CameraByIdLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraByIdLoadedActionTypes
            .CAMERABYIDLOADED_INPROGRESS
  }
}

/**
 * @function CameraByIdLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraByIdLoadedActionSuccess(data: any):
    ModelsFromStore.CameraByIdLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type:
            EnumsFromStore.CameraByIdLoadedActionTypes.CAMERABYIDLOADED_SUCCESS
  }
}



/**
 * @function GetZoneByIdCameraLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetZoneByIdCameraLoadedActionFail(error: any):
    ModelsFromStore.GetZoneByIdCameraLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.GetZoneByIdCameraLoadedActionTypes
            .GETZONEBYIDCAMERALOADED_FAIL
  }
}

/**
 * @function GetZoneByIdCameraLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetZoneByIdCameraLoadedActionInProgress():
    ModelsFromStore.GetZoneByIdCameraLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.GetZoneByIdCameraLoadedActionTypes
            .GETZONEBYIDCAMERALOADED_INPROGRESS
  }
}
/**
 * @function GetZoneByIdCameraLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetZoneByIdCameraLoadedActionSuccess(data: any):
    ModelsFromStore.GetZoneByIdCameraLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.GetZoneByIdCameraLoadedActionTypes
            .GETZONEBYIDCAMERALOADED_SUCCESS
  }
}

/**
 * @function GetZoneByIdCameraLoadedActionReset  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetZoneByIdCameraLoadedActionReset():
    ModelsFromStore.GetZoneByIdCameraLoadedActionReset {
  return {
    type: EnumsFromStore.GetZoneByIdCameraLoadedActionTypes
        .GETZONEBYIDCAMERALOADED_RESET
  }
}


/**
 * @function GetAllZoneForMaskLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetAllZoneForMaskLoadedActionFail(error: any):
    ModelsFromStore.GetAllZoneForMaskLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.GetAllZoneForMaskLoadedActionTypes
            .GETALLZONEFORMASKLOADED_FAIL
  }
}

/**
 * @function GetAllZoneForMaskLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetAllZoneForMaskLoadedActionInProgress():
    ModelsFromStore.GetAllZoneForMaskLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.GetAllZoneForMaskLoadedActionTypes
            .GETALLZONEFORMASKLOADED_INPROGRESS
  }
}

/**
 * @function GetAllZoneForMaskLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetAllZoneForMaskLoadedActionSuccess(data: any):
    ModelsFromStore.GetAllZoneForMaskLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.GetAllZoneForMaskLoadedActionTypes
            .GETALLZONEFORMASKLOADED_SUCCESS
  }
}
/**
 * @function GetAllZoneForMaskLoadedActionReset  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetAllZoneForMaskLoadedActionReset():
    ModelsFromStore.GetAllZoneForMaskLoadedActionReset {
  return {
    type: EnumsFromStore.GetAllZoneForMaskLoadedActionTypes
        .GETALLZONEFORMASKLOADED_RESET
  }
}
/**
 * @function ProgressBarActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ProgressBarActionSuccess():
    ModelsFromStore.ProgressBarActionSuccess {
  return {
    type: EnumsFromStore.ProgressBarActionTypes.PROGRESSBAR_SUCCESS
  }
}

/**
 * @function ProgressBarActionReset  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ProgressBarActionReset():
    ModelsFromStore.ProgressBarActionReset {
  return {
    type: EnumsFromStore.ProgressBarActionTypes.PROGRESSBAR_RESET
  }
}


/**
 * @function ProgressBarActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ProgressBarActionFail(error: any):
    ModelsFromStore.ProgressBarActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ProgressBarActionTypes.PROGRESSBAR_FAIL
  }
}



/**
 * @function GetCameraBeforeAndAfterByLocationActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetCameraBeforeAndAfterByLocationActionInProgress():
    ModelsFromStore.GetCameraBeforeAndAfterByLocationActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.GetCameraBeforeAndAfterByLocationActionTypes
            .GETCAMERABEFOREANDAFTERBYLOCATION_INPROGRESS
  }
}
/**
 * @function GetCameraBeforeAndAfterByLocationActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetCameraBeforeAndAfterByLocationActionSuccess(data: any):
    ModelsFromStore.GetCameraBeforeAndAfterByLocationActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.GetCameraBeforeAndAfterByLocationActionTypes
            .GETCAMERABEFOREANDAFTERBYLOCATION_SUCCESS
  }
}

/**
 * @function GetCameraBeforeAndAfterByLocationActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function GetCameraBeforeAndAfterByLocationActionFail(error: any):
    ModelsFromStore.GetCameraBeforeAndAfterByLocationActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.GetCameraBeforeAndAfterByLocationActionTypes
            .GETCAMERABEFOREANDAFTERBYLOCATION_FAIL
  }
}



/**
 * @function ParametersDisplayUpdatedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ParametersDisplayUpdatedActionInProgress():
    ModelsFromStore.ParametersDisplayUpdatedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ParametersDisplayUpdatedActionTypes
            .PARAMETERDISPLAYUPDATED_INPROGRESS
  }
}
/**
 * @function ParametersDisplayUpdatedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ParametersDisplayUpdatedActionSuccess(data: any):
    ModelsFromStore.ParametersDisplayUpdatedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ParametersDisplayUpdatedActionTypes
            .PARAMETERDISPLAYUPDATED_SUCCESS
  }
}

/**
 * @function ParametersDisplayLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ParametersDisplayLoadedActionFail(error: any):
    ModelsFromStore.ParametersDisplayLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ParametersDisplayLoadedActionTypes
            .PARAMETERDISPLAYLOADED_FAIL
  }
}

/**
 * @function ParametersDisplayLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ParametersDisplayLoadedActionInProgress():
    ModelsFromStore.ParametersDisplayLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ParametersDisplayLoadedActionTypes
            .PARAMETERDISPLAYLOADED_INPROGRESS
  }
}
/**
 * @function ParametersDisplayLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ParametersDisplayLoadedActionSuccess(data: any):
    ModelsFromStore.ParametersDisplayLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ParametersDisplayLoadedActionTypes
            .PARAMETERDISPLAYLOADED_SUCCESS
  }
}

/**
 * @function ParametersDisplayUpdatedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ParametersDisplayUpdatedActionFail(error: any):
    ModelsFromStore.ParametersDisplayUpdatedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ParametersDisplayUpdatedActionTypes
            .PARAMETERDISPLAYUPDATED_FAIL
  }
}



/**
 * @function SimulatorActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SimulatorActionInProgress():
    ModelsFromStore.SimulatorActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.SimulatorActionTypes.SIMULATOR_INPROGRESS
  }
}
/**
 * @function SimulatorActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SimulatorActionSuccess(data: any):
    ModelsFromStore.SimulatorActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.SimulatorActionTypes.SIMULATOR_SUCCESS
  }
}

/**
 * @function SimulatorActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SimulatorActionFail(error: any):
    ModelsFromStore.SimulatorActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.SimulatorActionTypes.SIMULATOR_FAIL
  }
}



/**
 * @function ModalInhibitionsLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ModalInhibitionsLoadedActionInProgress():
    ModelsFromStore.ModalInhibitionsLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ModalInhibitionsLoadedActionTypes
            .MODALINHIBITIONSLOADED_INPROGRESS
  }
}
/**
 * @function ModalInhibitionsLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ModalInhibitionsLoadedActionSuccess(data: any):
    ModelsFromStore.ModalInhibitionsLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ModalInhibitionsLoadedActionTypes
            .MODALINHIBITIONSLOADED_SUCCESS
  }
}

/**
 * @function ModalInhibitionsLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ModalInhibitionsLoadedActionFail(error: any):
    ModelsFromStore.ModalInhibitionsLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ModalInhibitionsLoadedActionTypes
            .MODALINHIBITIONSLOADED_FAIL
  }
}



/**
 * @function ModalInhibitionsUpdatedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ModalInhibitionsUpdatedActionInProgress():
    ModelsFromStore.ModalInhibitionsUpdatedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ModalInhibitionsUpdatedActionTypes
            .MODALINHIBITIONSUPDATED_INPROGRESS
  }
}
/**
 * @function ModalInhibitionsUpdatedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ModalInhibitionsUpdatedActionSuccess(data: any):
    ModelsFromStore.ModalInhibitionsUpdatedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ModalInhibitionsUpdatedActionTypes
            .MODALINHIBITIONSUPDATED_SUCCESS
  }
}

/**
 * @function ModalInhibitionsUpdatedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ModalInhibitionsUpdatedActionFail(error: any):
    ModelsFromStore.ModalInhibitionsUpdatedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ModalInhibitionsUpdatedActionTypes
            .MODALINHIBITIONSUPDATED_FAIL
  }
}



/**
 * @function IncidentInhibateLocalLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateLocalLoadedActionSuccess(data: any):
    ModelsFromStore.IncidentInhibateLocalLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.IncidentInhibateLocalLoadedActionTypes
            .INCIDENTINHIBATELOCALLOADED_SUCCESS
  }
}
/**
 * @function IncidentInhibateLocalLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateLocalLoadedActionFail(error: any):
    ModelsFromStore.IncidentInhibateLocalLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.IncidentInhibateLocalLoadedActionTypes
            .INCIDENTINHIBATELOCALLOADED_FAIL
  }
}

/**
 * @function IncidentInhibateLocalLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateLocalLoadedActionInProgress():
    ModelsFromStore.IncidentInhibateLocalLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.IncidentInhibateLocalLoadedActionTypes
            .INCIDENTINHIBATELOCALLOADED_INPROGRESS
  }
}


/**
 * @function IncidentInhibateGlobalLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateGlobalLoadedActionSuccess(data: any):
    ModelsFromStore.IncidentInhibateGlobalLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.IncidentInhibateGlobalLoadedActionTypes
            .INCIDENTINHIBATEGLOBALLOADED_SUCCESS
  }
}
/**
 * @function IncidentInhibateGlobalLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateGlobalLoadedActionFail(error: any):
    ModelsFromStore.IncidentInhibateGlobalLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.IncidentInhibateGlobalLoadedActionTypes
            .INCIDENTINHIBATEGLOBALLOADED_FAIL
  }
}

/**
 * @function IncidentInhibateGlobalLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateGlobalLoadedActionInProgress():
    ModelsFromStore.IncidentInhibateGlobalLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.IncidentInhibateGlobalLoadedActionTypes
            .INCIDENTINHIBATEGLOBALLOADED_INPROGRESS
  }
}
/**
 * @function IncidentInhibateLocalCreatedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateLocalCreatedActionSuccess(data: any):
    ModelsFromStore.IncidentInhibateLocalCreatedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.IncidentInhibateLocalCreatedActionTypes
            .INCIDENTINHIBATELOCALCREATED_SUCCESS
  }
}
/**
 * @function IncidentInhibateLocalCreatedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateLocalCreatedActionFail(error: any):
    ModelsFromStore.IncidentInhibateLocalCreatedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.IncidentInhibateLocalCreatedActionTypes
            .INCIDENTINHIBATELOCALCREATED_FAIL
  }
}

/**
 * @function IncidentInhibateLocalCreatedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateLocalCreatedActionInProgress():
    ModelsFromStore.IncidentInhibateLocalCreatedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.IncidentInhibateLocalCreatedActionTypes
            .INCIDENTINHIBATELOCALCREATED_INPROGRESS
  }
}



/**
 * @function IncidentInhibateLocalRemoveActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateLocalRemoveActionSuccess(data: any):
    ModelsFromStore.IncidentInhibateLocalRemoveActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.IncidentInhibateLocalRemoveActionTypes
            .INCIDENTINHIBATELOCALREMOVE_SUCCESS
  }
}
/**
 * @function IncidentInhibateLocalRemoveActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateLocalRemoveActionFail(error: any):
    ModelsFromStore.IncidentInhibateLocalRemoveActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.IncidentInhibateLocalRemoveActionTypes
            .INCIDENTINHIBATELOCALREMOVE_FAIL
  }
}

/**
 * @function IncidentInhibateLocalRemoveActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentInhibateLocalRemoveActionInProgress():
    ModelsFromStore.IncidentInhibateLocalRemoveActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.IncidentInhibateLocalRemoveActionTypes
            .INCIDENTINHIBATELOCALREMOVE_INPROGRESS
  }
}

/**
 * @function ReplayActionInProgress
 * @param { any }      data
 * @return { (object|string) }
 */
export function ReplayActionInProgress():
    ModelsFromStore.ReplayActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.ReplayActionTypes.REPLAY_INPROGRESS
  }
}

/**
 * @function ReplayActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ReplayActionFail(error: any): ModelsFromStore.ReplayActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ReplayActionTypes.REPLAY_FAIL
  }
}

/**
 * @function ReplayActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ReplayActionSuccess(data: any):
    ModelsFromStore.ReplayActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ReplayActionTypes.REPLAY_SUCCESS
  }
}
/**
 * @function ReplayActionInProgress
 * @param { any }      data
 * @return { (object|string) }
 */
export function ReplayDownloadActionInProgress():
    ModelsFromStore.ReplayDownloadActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type:
            EnumsFromStore.ReplayDownloadActionTypes.REPLAY_DOWNLOAD_INPROGRESS
  }
}

/**
 * @function ReplayDownloadActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ReplayDownloadActionFail(error: any):
    ModelsFromStore.ReplayDownloadActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.ReplayDownloadActionTypes.REPLAY_DOWNLOAD_FAIL
  }
}

/**
 * @function ReplayDownloadActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ReplayDownloadActionSuccess(data: any):
    ModelsFromStore.ReplayDownloadActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.ReplayDownloadActionTypes.REPLAY_DOWNLOAD_SUCCESS
  }
}

/**
 * @function CameraBySectionLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraBySectionLoadedActionFail(error: any):
    ModelsFromStore.CameraBySectionLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraBySectionLoadedActionTypes
            .CAMERABYSECTIONLOADED_FAIL
  }
}

/**
 * @function CameraBySectionLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraBySectionLoadedActionInProgress():
    ModelsFromStore.CameraBySectionLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraBySectionLoadedActionTypes
            .CAMERABYSECTIONLOADED_INPROGRESS
  }
}

/**
 * @function CameraBySectionLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraBySectionLoadedActionSuccess(data: any):
    ModelsFromStore.CameraBySectionLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraBySectionLoadedActionTypes
            .CAMERABYSECTIONLOADED_SUCCESS
  }
}

/**
 * @function CameraUpdateZoneActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraUpdateZoneActionFail(error: any):
    ModelsFromStore.CameraUpdateZoneActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraUpdateZoneActionTypes.CAMERAUPDATEZONE_FAIL
  }
}
/**
 * @function CameraUpdateZoneActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraUpdateZoneActionSuccess(data: any):
    ModelsFromStore.CameraUpdateZoneActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type:
            EnumsFromStore.CameraUpdateZoneActionTypes.CAMERAUPDATEZONE_SUCCESS
  }
}

/**
 * @function CameraUpdateZoneActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraUpdateZoneActionInProgress():
    ModelsFromStore.CameraUpdateZoneActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraUpdateZoneActionTypes
            .CAMERAUPDATEZONE_INPROGRESS
  }
}


/**
 * @function CameraSwitchSegmentedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSwitchSegmentedActionFail(error: any):
    ModelsFromStore.CameraSwitchSegmentedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraSwitchSegmentedActionTypes
            .CAMERASWITCHSEGMENTED_FAIL
  }
}
/**
 * @function CameraSwitchSegmentedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSwitchSegmentedActionSuccess(data: any):
    ModelsFromStore.CameraSwitchSegmentedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraSwitchSegmentedActionTypes
            .CAMERASWITCHSEGMENTED_SUCCESS
  }
}

/**
 * @function CameraSwitchSegmentedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSwitchSegmentedActionInProgress():
    ModelsFromStore.CameraSwitchSegmentedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraSwitchSegmentedActionTypes
            .CAMERASWITCHSEGMENTED_INPROGRESS
  }
}


/**
 * @function SectionSwitchSegmentedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSwitchSegmentedActionFail(error: any):
    ModelsFromStore.SectionSwitchSegmentedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.SectionSwitchSegmentedActionTypes
            .SECTIONSWITCHSEGMENTED_FAIL
  }
}
/**
 * @function SectionSwitchSegmentedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSwitchSegmentedActionSuccess(data: any):
    ModelsFromStore.SectionSwitchSegmentedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.SectionSwitchSegmentedActionTypes
            .SECTIONSWITCHSEGMENTED_SUCCESS
  }
}

/**
 * @function SectionSwitchSegmentedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSwitchSegmentedActionInProgress():
    ModelsFromStore.SectionSwitchSegmentedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.SectionSwitchSegmentedActionTypes
            .SECTIONSWITCHSEGMENTED_INPROGRESS
  }
}



/**
 * @function SectionSwitchSegmentedResetActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSwitchSegmentedResetActionFail(error: any):
    ModelsFromStore.SectionSwitchSegmentedResetActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.SectionSwitchSegmentedResetActionTypes
            .SECTIONSWITCHSEGMENTEDRESET_FAIL
  }
}
/**
 * @function SectionSwitchSegmentedResetActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSwitchSegmentedResetActionSuccess(data: any):
    ModelsFromStore.SectionSwitchSegmentedResetActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.SectionSwitchSegmentedResetActionTypes
            .SECTIONSWITCHSEGMENTEDRESET_SUCCESS
  }
}

/**
 * @function SectionSwitchSegmentedResetActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SectionSwitchSegmentedResetActionInProgress():
    ModelsFromStore.SectionSwitchSegmentedResetActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.SectionSwitchSegmentedResetActionTypes
            .SECTIONSWITCHSEGMENTEDRESET_INPROGRESS
  }
}


/**
 * @function VersionningActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function VersionningActionInProgress():
    ModelsFromStore.VersionningActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.VersionningActionTypes.VERSIONNING_INPROGRESS
  }
}

/**
 * @function VersionningActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function VersionningActionFail(error: any):
    ModelsFromStore.VersionningActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.VersionningActionTypes.VERSIONNING_FAIL
  }
}

/**
 * @function VersionningActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function VersionningActionSuccess(data: any):
    ModelsFromStore.VersionningActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.VersionningActionTypes.VERSIONNING_SUCCESS
  }
}


/**
 * @function EmailForgetPassWordActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function EmailForgetPassWordActionInProgress():
    ModelsFromStore.EmailForgetPassWordActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.EmailForgetPassWordActionTypes
            .EMAILFORGETPASSWORD_INPROGRESS
  }
}

/**
 * @function EmailForgetPassWordActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function EmailForgetPassWordActionFail(error: any):
    ModelsFromStore.EmailForgetPassWordActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.EmailForgetPassWordActionTypes
            .EMAILFORGETPASSWORD_FAIL
  }
}

/**
 * @function EmailForgetPassWordActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function EmailForgetPassWordActionSuccess(data: any):
    ModelsFromStore.EmailForgetPassWordActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.EmailForgetPassWordActionTypes
            .EMAILFORGETPASSWORD_SUCCESS
  }
}


/**
 * @function NewPassWordActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function NewPassWordActionInProgress():
    ModelsFromStore.NewPassWordActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.NewPassWordActionTypes.NEWPASSWORD_INPROGRESS
  }
}

/**
 * @function NewPassWordActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function NewPassWordActionFail(error: any):
    ModelsFromStore.NewPassWordActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.NewPassWordActionTypes.NEWPASSWORD_FAIL
  }
}

/**
 * @function  NewPassWordActionSuccess
 * @param { any }      data
 * @return { (object|string) }
 */
export function NewPassWordActionSuccess(data: any):
    ModelsFromStore.NewPassWordActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.NewPassWordActionTypes.NEWPASSWORD_SUCCESS
  }
}



/**
 * @function CameraSwitchSegmentedResetActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSwitchSegmentedResetActionFail(error: any):
    ModelsFromStore.CameraSwitchSegmentedResetActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.CameraSwitchSegmentedResetActionTypes
            .CAMERASWITCHSEGMENTEDRESET_FAIL
  }
}
/**
 * @function CameraSwitchSegmentedResetActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSwitchSegmentedResetActionSuccess(data: any):
    ModelsFromStore.CameraSwitchSegmentedResetActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.CameraSwitchSegmentedResetActionTypes
            .CAMERASWITCHSEGMENTEDRESET_SUCCESS
  }
}

/**
 * @function CameraSwitchSegmentedResetActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraSwitchSegmentedResetActionInProgress():
    ModelsFromStore.CameraSwitchSegmentedResetActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.CameraSwitchSegmentedResetActionTypes
            .CAMERASWITCHSEGMENTEDRESET_INPROGRESS
  }
}

/**
 * @function UsersLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersLoadedActionFail(error: any):
    ModelsFromStore.UsersLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.UsersLoadedActionTypes.USERSLOADED_FAIL
  }
}
/**
 * @function UsersLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersLoadedActionSuccess(data: any):
    ModelsFromStore.UsersLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.UsersLoadedActionTypes.USERSLOADED_SUCCESS
  }
}

/**
 * @function UsersLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersLoadedActionInProgress():
    ModelsFromStore.UsersLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.UsersLoadedActionTypes.USERSLOADED_INPROGRESS
  }
}


/**
 * @function UsersCreatedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersCreatedActionFail(error: any):
    ModelsFromStore.UsersCreatedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.UsersCreatedActionTypes.USERSCREATED_FAIL
  }
}
/**
 * @function UsersCreatedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersCreatedActionSuccess(data: any):
    ModelsFromStore.UsersCreatedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.UsersCreatedActionTypes.USERSCREATED_SUCCESS
  }
}

/**
 * @function UsersCreatedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersCreatedActionInProgress():
    ModelsFromStore.UsersCreatedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.UsersCreatedActionTypes.USERSCREATED_INPROGRESS
  }
}

/**
 * @function UsersRemovedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersRemovedActionFail(error: any):
    ModelsFromStore.UsersRemovedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.UsersRemovedActionTypes.USERSREMOVED_FAIL
  }
}
/**
 * @function UsersRemovedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersRemovedActionSuccess(data: any):
    ModelsFromStore.UsersRemovedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.UsersRemovedActionTypes.USERSREMOVED_SUCCESS
  }
}

/**
 * @function UsersRemovedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersRemovedActionInProgress():
    ModelsFromStore.UsersRemovedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.UsersRemovedActionTypes.USERSREMOVED_INPROGRESS
  }
}

/**
 * @function UsersUpdatedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersUpdatedActionFail(error: any):
    ModelsFromStore.UsersUpdatedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.UsersUpdatedActionTypes.USERSUPDATED_FAIL
  }
}
/**
 * @function UsersUpdatedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersUpdatedActionSuccess(data: any):
    ModelsFromStore.UsersUpdatedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.UsersUpdatedActionTypes.USERSUPDATED_SUCCESS
  }
}

/**
 * @function UsersUpdatedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function UsersUpdatedActionInProgress():
    ModelsFromStore.UsersUpdatedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.UsersUpdatedActionTypes.USERSUPDATED_INPROGRESS
  }
}


/**
 * @function DisplayParamVideoActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function DisplayParamVideoActionFail(error: any):
    ModelsFromStore.DisplayParamVideoActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.DisplayParamVideoActionTypes.DISPLAYPARAMVIDEO_FAIL
  }
}
/**
 * @function DisplayParamVideoActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function DisplayParamVideoActionSuccess(data: any):
    ModelsFromStore.DisplayParamVideoActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.DisplayParamVideoActionTypes
            .DISPLAYPARAMVIDEO_SUCCESS
  }
}

/**
 * @function DisplayParamVideoActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function DisplayParamVideoActionInProgress():
    ModelsFromStore.DisplayParamVideoActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.DisplayParamVideoActionTypes
            .DISPLAYPARAMVIDEO_INPROGRESS
  }
}


/**
 * @function DisplayParamVideoLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function DisplayParamVideoLoadedActionFail(error: any):
    ModelsFromStore.DisplayParamVideoLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.DisplayParamVideoLoadedActionTypes
            .DISPLAYPARAMVIDEOLOADED_FAIL
  }
}
/**
 * @function DisplayParamVideoLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function DisplayParamVideoLoadedActionSuccess(data: any):
    ModelsFromStore.DisplayParamVideoLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.DisplayParamVideoLoadedActionTypes
            .DISPLAYPARAMVIDEOLOADED_SUCCESS
  }
}

/**
 * @function DisplayParamVideoLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function DisplayParamVideoLoadedActionInProgress():
    ModelsFromStore.DisplayParamVideoLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.DisplayParamVideoLoadedActionTypes
            .DISPLAYPARAMVIDEOLOADED_INPROGRESS
  }
}



/**
 * @function StatsByCameraLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function StatsByCameraLoadedActionFail(error: any):
    ModelsFromStore.StatsByCameraLoadedActionFail {
  return {
    payload: {

      error,
      loading: false,

    },

        type: EnumsFromStore.StatsByCameraLoadedActionTypes
            .STATSBYCAMERALOADED_FAIL
  }
}
/**
 * @function StatsByCameraLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function StatsByCameraLoadedActionSuccess(data: any):
    ModelsFromStore.StatsByCameraLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,

    },

        type: EnumsFromStore.StatsByCameraLoadedActionTypes
            .STATSBYCAMERALOADED_SUCCESS
  }
}

/**
 * @function StatsByCameraLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function StatsByCameraLoadedActionInProgress():
    ModelsFromStore.StatsByCameraLoadedActionInProgress {
  return {
    payload: {

      loading: true,

    },

        type: EnumsFromStore.StatsByCameraLoadedActionTypes
            .STATSBYCAMERALOADED_INPROGRESS
  }
}


/**
 * @function CheckCameraZoneMaskActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CheckCameraZoneMaskActionSuccess(data: any):
    ModelsFromStore.CheckCameraZoneMaskActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.CheckCameraZoneMaskActionTypes
            .CHECKCAMERAZONEMASK_SUCCESS
  }
}

/**
 * @function CheckCameraZoneMaskActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CheckCameraZoneMaskActionFail(errors: any):
    ModelsFromStore.CheckCameraZoneMaskActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.CheckCameraZoneMaskActionTypes
            .CHECKCAMERAZONEMASK_FAIL
  }
}
/**
 * @function CheckCameraZoneMaskActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CheckCameraZoneMaskActionInProgress():
    ModelsFromStore.CheckCameraZoneMaskActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.CheckCameraZoneMaskActionTypes
            .CHECKCAMERAZONEMASK_INPROGRESS
  }
}

/**
 * @function ExportCameraCSVLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExportCameraCSVLoadedActionSuccess(data: any):
    ModelsFromStore.ExportCameraCSVLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.ExportCameraCSVLoadedActionTypes
            .EXPORTCAMERACSVLOADED_SUCCESS
  }
}

/**
 * @function ExportCameraCSVLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExportCameraCSVLoadedActionFail(errors: any):
    ModelsFromStore.ExportCameraCSVLoadedActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.ExportCameraCSVLoadedActionTypes
            .EXPORTCAMERACSVLOADED_FAIL
  }
}
/**
 * @function ExportCameraCSVLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExportCameraCSVLoadedActionInProgress():
    ModelsFromStore.ExportCameraCSVLoadedActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.ExportCameraCSVLoadedActionTypes
            .EXPORTCAMERACSVLOADED_INPROGRESS
  }
}

/**
 * @function InhibitionByCameraLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function InhibitionByCameraLoadedActionSuccess(data: any):
    ModelsFromStore.InhibitionByCameraLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.InhibitionByCameraLoadedActionTypes
            .INHIBITIONBYCAMERALOADED_SUCCESS
  }
}

/**
 * @function InhibitionByCameraLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function InhibitionByCameraLoadedActionFail(errors: any):
    ModelsFromStore.InhibitionByCameraLoadedActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.InhibitionByCameraLoadedActionTypes
            .INHIBITIONBYCAMERALOADED_FAIL
  }
}
/**
 * @function InhibitionByCameraLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function InhibitionByCameraLoadedActionInProgress():
    ModelsFromStore.InhibitionByCameraLoadedActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.InhibitionByCameraLoadedActionTypes
            .INHIBITIONBYCAMERALOADED_INPROGRESS
  }
}

/**
 * @function LapiAndTmpLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function LapiAndTmpLoadedActionSuccess(data: any):
    ModelsFromStore.LapiAndTmpLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type:
            EnumsFromStore.LapiAndTmpLoadedActionTypes.LAPIANDTMPLOADED_SUCCESS
  }
}

/**
 * @function LapiAndTmpLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function LapiAndTmpLoadedActionFail(errors: any):
    ModelsFromStore.LapiAndTmpLoadedActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.LapiAndTmpLoadedActionTypes.LAPIANDTMPLOADED_FAIL
  }
}
/**
 * @function LapiAndTmpLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function LapiAndTmpLoadedActionInProgress():
    ModelsFromStore.LapiAndTmpLoadedActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.LapiAndTmpLoadedActionTypes
            .LAPIANDTMPLOADED_INPROGRESS
  }
}


/**
 * @function IncidentstmdLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentstmdLoadedActionSuccess(data: any):
    ModelsFromStore.IncidentstmdLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.IncidentstmdLoadedActionTypes
            .INCIDENTSTMDLOADED_SUCCESS
  }
}

/**
 * @function IncidentstmdLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentstmdLoadedActionFail(errors: any):
    ModelsFromStore.IncidentstmdLoadedActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type:
            EnumsFromStore.IncidentstmdLoadedActionTypes.INCIDENTSTMDLOADED_FAIL
  }
}
/**
 * @function IncidentstmdLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function IncidentstmdLoadedActionInProgress():
    ModelsFromStore.IncidentstmdLoadedActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.IncidentstmdLoadedActionTypes
            .INCIDENTSTMDLOADED_INPROGRESS
  }
}
/**
 * @function CameraLapiTmdLoadedActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraLapiTmdLoadedActionSuccess(data: any):
    ModelsFromStore.CameraLapiTmdLoadedActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.CameraLapiTmdLoadedActionTypes
            .CAMERALAPITMDLOADED_SUCCESS
  }
}

/**
 * @function CameraLapiTmdLoadedActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraLapiTmdLoadedActionFail(errors: any):
    ModelsFromStore.CameraLapiTmdLoadedActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.CameraLapiTmdLoadedActionTypes
            .CAMERALAPITMDLOADED_FAIL
  }
}
/**
 * @function CameraLapiTmdLoadedActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function CameraLapiTmdLoadedActionInProgress():
    ModelsFromStore.CameraLapiTmdLoadedActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.CameraLapiTmdLoadedActionTypes
            .CAMERALAPITMDLOADED_INPROGRESS
  }
}
/**
 * @function ExtrairePdfTmdActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtrairePdfTmdActionSuccess(data: any):
    ModelsFromStore.ExtrairePdfTmdActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.ExtrairePdfTmdActionTypes.EXTRAIREPDFTMD_SUCCESS
  }
}

/**
 * @function ExtrairePdfTmdActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtrairePdfTmdActionFail(errors: any):
    ModelsFromStore.ExtrairePdfTmdActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.ExtrairePdfTmdActionTypes.EXTRAIREPDFTMD_FAIL
  }
}
/**
 * @function ExtrairePdfTmdActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function ExtrairePdfTmdActionInProgress():
    ModelsFromStore.ExtrairePdfTmdActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.ExtrairePdfTmdActionTypes.EXTRAIREPDFTMD_INPROGRESS
  }
}
/**
 * @function SearchlapiTmdIncidentActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SearchlapiTmdIncidentActionSuccess(data: any):
    ModelsFromStore.SearchlapiTmdIncidentActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.SearchlapiTmdIncidentActionTypes
            .SEARCHLAPITMDINCIDENT_SUCCESS
  }
}

/**
 * @function SearchlapiTmdIncidentActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SearchlapiTmdIncidentActionFail(errors: any):
    ModelsFromStore.SearchlapiTmdIncidentActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.SearchlapiTmdIncidentActionTypes
            .SEARCHLAPITMDINCIDENT_FAIL
  }
}
/**
 * @function SearchlapiTmdIncidentActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function SearchlapiTmdIncidentActionInProgress():
    ModelsFromStore.SearchlapiTmdIncidentActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.SearchlapiTmdIncidentActionTypes
            .SEARCHLAPITMDINCIDENT_INPROGRESS
  }
}
/**
 * @function QualificationIncidentTmdActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function QualificationIncidentTmdActionSuccess(data: any):
    ModelsFromStore.QualificationIncidentTmdActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.QualificationIncidentTmdActionTypes
            .QUALIFICATIONINCIDENTTMD_SUCCESS
  }
}

/**
 * @function QualificationIncidentTmdActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function QualificationIncidentTmdActionFail(errors: any):
    ModelsFromStore.QualificationIncidentTmdActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.QualificationIncidentTmdActionTypes
            .QUALIFICATIONINCIDENTTMD_FAIL
  }
}
/**
 * @function QualificationIncidentTmdActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function QualificationIncidentTmdActionInProgress():
    ModelsFromStore.QualificationIncidentTmdActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.QualificationIncidentTmdActionTypes
            .QUALIFICATIONINCIDENTTMD_INPROGRESS
  }
}
/**
 * @function FilterIncidentTmdActionSuccess  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function FilterIncidentTmdActionSuccess(data: any):
    ModelsFromStore.FilterIncidentTmdActionSuccess {
  return {
    payload: {

      data,
      loading: false,


    },

        type: EnumsFromStore.FilterIncidentTmdActionTypes
            .FILTERINCIDENTTMD_SUCCESS
  }
}

/**
 * @function FilterIncidentTmdActionFail  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function FilterIncidentTmdActionFail(errors: any):
    ModelsFromStore.FilterIncidentTmdActionFail {
  return {
    payload: {

      error: errors,
      loading: false,

    },

        type: EnumsFromStore.FilterIncidentTmdActionTypes.FILTERINCIDENTTMD_FAIL
  }
}
/**
 * @function FilterIncidentTmdActionInProgress  -
 * @param { any }      data
 * @return { (object|string) }
 */
export function FilterIncidentTmdActionInProgress():
    ModelsFromStore.FilterIncidentTmdActionInProgress {
  return {
    payload: {


      loading: true,

    },

        type: EnumsFromStore.FilterIncidentTmdActionTypes
            .FILTERINCIDENTTMD_INPROGRESS
  }
}


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actions/tunnel/index.ts